import axios from 'axios';
import { strictEqual } from 'assert';
import * as Api from '@/api';
import { v2ApiErrorHandler } from '@/api/lib/error-handler';

export const listTagCategoriesForSchool = async ({
    schoolId,
    page = 1,
    page_size = 10,
    search = '',
    errorHandlerOptions = {}
} = {}) => {
    try {
        strictEqual(typeof schoolId, 'string');
        strictEqual(typeof page, 'number');
        strictEqual(typeof page_size, 'number');

        const url = Api.getv2ApiBase(`/tag-category`);
        const options = Api.getOptions();
        const params = {
            page,
            page_size,
            school_id: schoolId,
            // v2 and slim were introduced when transitioning from Django to Node.
            // So far the UI has only used `true` for both, so they're hardcoded here.
            v2: true,
            slim: true
        };

        if (typeof search === 'string' && search.length > 0) {
            params.search = search;
        }

        const response = await axios.get(url, { ...options, params });
        return response.data;
    } catch (error) {
        v2ApiErrorHandler({
            error,
            overrideMessage: 'There was a problem loading the Tag Categories. Please try again.',
            ...errorHandlerOptions
        });
    }
};
